import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-admin';
import { FieldProps } from '../../types';

/**
 * Component to display a user field in the charge list
 * Uses the embedded user object from the charge API response
 */
const ChargeUserField: React.FC<FieldProps<any>> = ({
    record,
    link = false,
}) => {
    if (!record) return null;

    // Handle both nested user object and direct userId
    const user = record.user;
    const userId = user?.id || record.userId;
    const userName = user?.name || user?.email;

    if (!userId) return <span>-</span>;
    if (!userName) return <span>{userId}</span>;

    return link ? (
        <Link to={`/users/${userId}/show`}>{userName}</Link>
    ) : (
        <span>{userName}</span>
    );
};

ChargeUserField.propTypes = {
    record: PropTypes.object,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    label: PropTypes.string,
};

ChargeUserField.defaultProps = {
    addLabel: true,
    label: 'Customer',
};

export default ChargeUserField;
